<template>
<div class="bottompic">
<img src="https://static.igem.wiki/teams/5298/assets/tongjilogo.png" style="width:20vw;margin-left: 3vw;margin-top: 13vh;">
<img src="https://static.igem.wiki/teams/5298/assets/bottomlogo.png" style="width:15vw;margin-left: 5vw;">
<img src="https://static.igem.wiki/teams/5298/assets/bottom-mascot.png" style="width:9vw;margin-left: 5vw">
<div style="margin-left: 3vw;">
<p style="font-size: 1vw;margin-top: 5vh;">@ 2024 - Content on this site is licensed under a <el-link href="https://creativecommons.org/licenses/by/4.0/" target="_blank" style="font-size: 1vw;">Creative Commons Attribution 4.0 International license.</el-link></p>
</div>
<div style="margin-left: 3vw;">
<p style="font-size: 1vw;margin-top: 2vh;">The repository used to create this website is avalable at <el-link href="https://gitlab.igem.org/2024/tongji-china" target="_blank" style="font-size: 1vw;">gitlab.igem.orc/2024/tongii-china</el-link>.</p>
</div>
</div>
</template>

<style>
.bottompic{
    width:99.5vw;
    height:38vh;
    background: url(https://static.igem.wiki/teams/5298/assets/bottompic.jpg) no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
}
</style>